//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { lighten, makeStyles, styled } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import { CircularProgress } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import IconButton from "@material-ui/core/IconButton";
import {useTranslation} from "react-i18next";

//Child Components
import MiddleHeader from "../middleHeader/middleHeader";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";
import Spinner from "../../Global/Spinner2";
import DarkButton from "../../Global/DarkButton";
import NoRecords from "../../Global/NoRecords";



//Custom Css + Images
import "./templateReportList.css";
import pencil from "../../Assets/pencil.png";
import pencilG from "../../Assets/pencilG.png";
import placeholder from "../../Assets/placeholder.jpg";
import search from "../../Assets/search.png";
import file from "../../Assets/file.png";
import help from '../../Assets/help_icon.png';
import helpAr from '../../Assets/help_icon_ar.png';

//React Router
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Others
import { LazyLoadImage } from 'react-lazy-load-image-component';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

function TemplateReportList() {
  const {t} = useTranslation();
  const classes = useStyles();
  const [selctedUsers, setSelectedUsers] = useState([]);
  const [selectedAccess, setSelectedAccess] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [tempLoader, setTempLoader] = useState(false);
  const [rows, setRows] = useState([]);
  const [permissions_obj, setPermissionObj] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentUser, setCurrentUser] = useState({});
  const [currentCompany, setCurrentCompany] = useState({});
  let history = useHistory();
  let userData = useSelector((state) => state.userReducer.user);
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  React.useEffect(
    () => {
      setCurrentCompany(company);
      let localstorage = localStorage.getItem("UserData");
      var data = JSON.parse(localstorage);
      setCurrentUser(data);
      getTemplates(company);
      getPermissions();
    },
    [company?.id]
  );

  const getPermissions = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();

            if (status) {
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("Error", error.message);
        });
    }
  };

  const handleScroll = (e) => {
    let currentRecords = rows.length;
    const bottom =
      e.target.scrollHeight - Math.ceil(e.target.scrollTop) ===
      e.target.clientHeight;
    const top = e.target.scrollTop == 0;
    if (bottom) {
      if (currentRecords < totalRecords) {
        getMoreTemplates(currentCompany);
      }
    }
  };

  const getTemplates = async (currentCompany) => {
    setTempLoader(true);
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    //this.setState({loader:true})
    var params = {
      skip: 0,
      noOfRecords: 12,
      company_id: currentCompany.id,
      user_id: data.user_id,
    };
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi +
        "/TemplateShare/get_all_template_shares_for_user?" +
        query +
        "&access_to=" +
        JSON.stringify(selctedUsers) +
        "&shared_with=" +
        JSON.stringify(selectedAccess),
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          setTotalRecords(res.total_records);
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            if (data.report_template !== null || undefined) {
              var template = {
                id: data?.id,
                name: data?.title,
                description: data?.description,
                report_template_id: data?.report_template_id,
                report_style: data?.report_template?.report_template_type,
                report_key: data?.report_template?.report_template_key,
                report_theme: data?.report_template?.themes,
                scheduled: data?.Schedules?.length > 0 ? "Yes" : "no",
                modified: "",
                shared: data.TemplateShares?.length > 1 ? "Yes" : "no",
                createdBy: data.created_by,
                createdAt: data.createdAt,
                status: data.status,
                TemplateShares: data.TemplateShares,
                created_by: data.created_by,
              };
              templateList.push(template);
            } else {
              console.log("::::::::::::::::::::::::::::::::::::::", data);
            }
          });
          //this.setState({rows:templateList,loader:false})
          setRows(
            templateList.sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          );
          setTempLoader(false);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
          }
        }
      })
      .catch((err) => {
        setTempLoader(false);
        console.log(err, "error");
      });
  };

  const getMoreTemplates = async (currentCompany) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    var params = {
      skip: rows.length,
      noOfRecords: 12,
      company_id: currentCompany.id,
      user_id: data.user_id,
    };
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi +
        "/TemplateShare/get_all_template_shares_for_user?" +
        query +
        "&access_to=" +
        JSON.stringify(selctedUsers) +
        "&shared_with=" +
        JSON.stringify(selectedAccess),
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          setTotalRecords(res.total_records);
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            if (data.report_template !== null || undefined) {
              var template = {
                id: data?.id,
                name: data?.title,
                description: data?.description,
                report_template_id: data?.report_template_id,
                report_style: data?.report_template?.report_template_type,
                report_key: data?.report_template?.report_template_key,
                report_theme: data?.report_template?.themes,
                scheduled: data?.Schedules?.length > 0 ? "Yes" : "no",
                modified: "",
                shared: data.TemplateShares?.length > 1 ? "Yes" : "no",
                createdBy: data.created_by,
                createdAt: data?.createdAt,
                status: data?.status,
                TemplateShares: data?.TemplateShares,
                created_by: data?.created_by,
              };
              templateList.push(template);
            } else {
              console.log("::::::::::::::::::::::::::::::::::::::", data);
            }
          });

          let TotalRows = [...templateList, ...rows];

          //this.setState({rows:templateList,loader:false})
          setRows(
            TotalRows.sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          );
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
          }
        }
      })
      .catch((err) => {
        setTempLoader(false);
        console.log(err, "error");
      });
  };

  return (
    <>
      <MiddleHeader />
      <div
        style={{
          width: "100%", // minHeight: "75vh",
          padding: "20px 30px",
          overflow: "auto",
          backgroundColor: "#eaf7fe",
        }}
      >
        {/* ================================== Top Search and filter bar ========================= */}

        {/* ================================== Recently Created Templates  ========================= */}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          className=" shadow"
          style={{
            backgroundColor: "white",
            padding: "5px 0px",
            borderRadius: "5px",
            marginTop: "0px",
            overflowY: "hidden",
          }}
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            style={{
              padding: "5px 20px",
              borderBottomWidth: "1px",
              borderBottomStyle: "solid",
              borderBottomColor: Colors.globalColor4,
            }}
          >
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <div>
                <p
                  className="label2"
                  style={{
                    marginBottom: 5,
                    fontSize: 14,
                    marginTop: 7,
                    color: Colors.globalColor8,
                    textTransform: "uppercase",
                  }}
                >
                  {t("My Template Reports")}
                </p>
              </div>
            </div>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "white",
                padding: "0px",
                borderRadius: "5px",
                marginBottom: "2px",
              }}
            >
              <Grid item xs={12} lg={4} style={{display:'flex', alignItems:'center'}}>
                <TextField
                  size="small"
                  autoComplete="off"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src={search} width={12} />
                      </InputAdornment>
                    ),
                    classes: { input: classes.resize },
                  }}
                  placeholder={t("Search in existing Templates")}
                  fullWidth
                  onChange={(e) => setSearchText(e.target.value)}
                  variant="outlined"
                  style={{
                    width: "80%",
                    marginTop: window.innerWidth < 700 ? "10px" : 0,
                    backgroundColor: Colors.globalColor5,
                  }}
                />
                  <Tooltip title={t("Help")}>

                <a href="https://www.uraudits.com/knowledge-center/template/" target="blank" style={{color:Colors.globalColor8}}>
                <img src={language == "ar" ? helpAr : help} height={25} style={{marginLeft:'5px', marginTop:'5px'}}/>
                  </a>
          
              </Tooltip>
              </Grid>

              <Grid item xs={12} lg={6} />

            {rows.length > 0 && <Grid
              item
              xs={12}
              sm={12}
              md={2}
              style={{
                textAlign: window.innerWidth > 700 ? (language == "ar" ? "left" : "right") : "center",
              }}
            >
              {searchText == "" && (
                <p
                  className="label2"
                  style={{
                    textAlign: window.innerWidth > 700 ? (language == "ar" ? "left" : "right") : "center",
                    display: "inline",
                    marginTop: 8,
                    fontSize: 12,
                    color: "grey",
                    textTransform: "capitalized",
                  }}
                >
                  {t("showing records")} {rows.length} {t("of")} {totalRecords}
                </p>
              )}
            </Grid>}
            </Grid>
          </Grid>
          <div
            className="scrollbarShow2"
            style={{ overflowY: "scroll", overflowX: "hidden", width: "100%" }}
            id="TemplateReportScroll"
            onScroll={(e) => handleScroll(e)}
          >
            <Grid
              className="scrollHidden"
              container
              justifyContent="center"
              spacing={1}
              style={{ padding: "20px", maxHeight: "63vh" }}
            >
              {tempLoader && (
                <div
                  style={{ width: "100%", textAlign: "center", padding: 20 }}
                >
                  <Spinner />
                </div>
              )}
              {!tempLoader && (
                <>
                  {rows.length !== 0 ? (
                    rows
                      .filter((v) =>
                        v.name
                          ?.toLowerCase()
                          .includes(searchText?.toLowerCase())
                      )
                      .map((row, index) => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={2}
                            xl={2}
                            justifyContent="center"
                            alignItems="flex-end"
                          >
                            <div
                              style={{
                                display: "inline-flex",
                                flexDirection: "column",
                                border: "1px solid #dadada",
                                padding: "10px",
                                margin: "5px",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                                textAlign: "left",
                                height: "280px",
                                borderRadius: "5px",
                                backgroundColor: Colors.globalColor5,
                              }}
                            >
                              <div style={{ padding: "20px" }}>
                                {row.report_key ? (
                                  // <img
                                  //   src={
                                  //     "https://server.uraudits.com/view?Key=" +
                                  //     row.report_key
                                  //   }
                                  //   width={"100%"}
                                  //   height={"150px"}
                                  //   style={{
                                  //     objectFit: "cover",
                                  //     border: "1px solid #dadada",
                                  //   }}
                                  // />
                                  <LazyLoadImage
                                  alt={"Report Style"}
                                  height={"150px"}
                                  style={{
                                        objectFit: "cover",
                                        border: "1px solid #dadada",
                                      }}
                                  src={"https://server.uraudits.com/view?Key=" +  row.report_key} // use normal <img> attributes as props
                                  width={"100%"} />
                                ) : (
                                  <img
                                    src={placeholder}
                                    width={"100%"}
                                    height={"150px"}
                                    style={{
                                      objectFit: "cover",
                                      borderRadius: "0px",
                                    }}
                                  />
                                )}
                              </div>
                              <hr
                                style={{
                                  borderTop: "1px solid #e5ecef",
                                  borderBottom: "none",
                                  marginTop: 0,
                                  width: "100%",
                                  marginBottom: 0,
                                }}
                              />

                              <Grid
                                container
                                xs={12}
                                style={{ justifyContent: "space-between" }}
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Grid item>
                                  <p
                                    className="templateName"
                                    style={{
                                      margin: "2px 0px",
                                      fontSize: 12,
                                      fontWeight: "bolder",
                                      textAlign: "left",
                                    }}
                                  >
                                    {row.name.slice(0, 20) +
                                      (row.name.length > 20 ? "..." : "")}
                                  </p>
                                  <p
                                    className="templateIndustry"
                                    style={{
                                      margin: "2px 0px",
                                      fontSize: 12,
                                      fontWeight: "bolder",
                                      textAlign: "left",
                                      color: "grey",
                                    }}
                                  >
                                    {row.report_style}
                                  </p>
                                </Grid>
                                <Grid item>
                                  {userData?.super_admin == true ||
                                  permissions_obj["Admin"] == true ||
                                  permissions_obj[
                                    "Manage Report Preferences"
                                  ] == true ? (
                                    <img
                                      src={pencil}
                                      width={20}
                                      alt="edit"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        history.push(
                                          "/template-report-style" +
                                            "/" +
                                            row.id +
                                            "/" +
                                            row.name
                                        )
                                      }
                                    />
                                  ) : (
                                    <img src={pencilG} width={20} alt="edit" />
                                  )}
                                </Grid>
                              </Grid>
                            </div>
                          </Grid>
                        );
                      })
                  ) : (
                    <div
                      style={{
                        padding: "20px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "60vh",
                      }}
                    >
                      <NoRecords />
                    </div>
                  )}
                </>
              )}
            </Grid>
          </div>
        </Grid>
      </div>
    </>
  );
}

export default TemplateReportList;
